export function SelectedFileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6 1.2H1.4C1.28954 1.2 1.2 1.28954 1.2 1.4V14.6C1.2 14.7105 1.28954 14.8 1.4 14.8H14.6C14.7105 14.8 14.8 14.7105 14.8 14.6V1.4C14.8 1.28954 14.7105 1.2 14.6 1.2ZM1.4 0C0.626801 0 0 0.626801 0 1.4V14.6C0 15.3732 0.626801 16 1.4 16H14.6C15.3732 16 16 15.3732 16 14.6V1.4C16 0.626801 15.3732 0 14.6 0H1.4Z"
        fill="white"
      />
      <rect x="3" y="3" width="3" height="1.4" rx="0.7" fill="white" />
      <rect x="7" y="3" width="6" height="1.4" rx="0.7" fill="white" />
      <rect x="3" y="6" width="3" height="1.4" rx="0.7" fill="white" />
      <rect x="7" y="6" width="6" height="1.4" rx="0.7" fill="white" />
      <rect x="3" y="9" width="3" height="1.4" rx="0.7" fill="white" />
      <rect x="7" y="9" width="6" height="1.4" rx="0.7" fill="white" />
    </svg>
  );
}
